module.exports = __webpack_public_path__ + "img/icon_item1.7d8ce67e.png";